import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e25d5694"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "formPage"
}
const _hoisted_2 = { class: "notification bulmaNotification is-warning mt-4" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_6 = {
  key: 2,
  class: "formPage"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = ["value"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Let's get you up and running!", -1))
const _hoisted_11 = { class: "infoBox mt-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle mr-3" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("This page is for citizens under the care of ")
const _hoisted_14 = /*#__PURE__*/_createTextVNode(".")
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-5" }, [
  /*#__PURE__*/_createTextVNode("This process should take around "),
  /*#__PURE__*/_createElementVNode("strong", null, "5 minutes"),
  /*#__PURE__*/_createTextVNode(", and then you'll be ready to apply for ID and benefits.")
], -1))
const _hoisted_17 = { key: 2 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please read the following important terms and conditions before using Mini City", -1))
const _hoisted_19 = { class: "column termsWrapper" }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please select your location and caseworker", -1))
const _hoisted_22 = {
  key: 2,
  class: "infoBox mt-4 mb-5"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle mr-3" }),
  /*#__PURE__*/_createElementVNode("strong", null, "Please be sure to select the most appropriate type of housing, for the best chance of being accepted.")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/_createTextVNode("Citizens who are chronically homeless, and experience disability-related barriers, should select "),
  /*#__PURE__*/_createElementVNode("strong", null, "Permanent Supportive Housing"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-3" }, [
  /*#__PURE__*/_createTextVNode("All other citizens should select "),
  /*#__PURE__*/_createElementVNode("strong", null, "Rapid Rehousing"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_26 = [
  _hoisted_23,
  _hoisted_24,
  _hoisted_25
]
const _hoisted_27 = { key: 4 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please take a photo of yourself to verify your identity", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "infoBox mt-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle mr-3" }),
    /*#__PURE__*/_createElementVNode("strong", null, "Do not share any sensitive information with your ambassador!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "The ambassador is here to answer your questions, and to help if you get stuck."),
  /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "But you should fill out the form yourself, and should not share sensitive information (like your password or Social Security number) with them.")
], -1))
const _hoisted_30 = { key: 5 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "It's time to pick a username, and set your password!", -1))
const _hoisted_32 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_33 = { key: 6 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please provide some basic information about yourself", -1))
const _hoisted_35 = {
  class: "column",
  style: {"padding-top":"2.75rem"}
}
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" You are ")
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" old ")
const _hoisted_39 = { key: 7 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please share your contact information", -1))
const _hoisted_41 = {
  key: 0,
  class: "notification bulmaNotification is-warning mt-4"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Without an email address, we will not be able to keep you updated about your ID and benefits applications", -1))
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = { key: 8 }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please let us know which of the following apply to you, so we can find tailored resources and support", -1))
const _hoisted_46 = { key: 9 }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please tell us which of the following would be most helpful for you", -1))
const _hoisted_48 = { key: 10 }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please answer a few additional questions about your circumstances and needs", -1))
const _hoisted_50 = { key: 11 }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please answer a few additional questions about your circumstances and needs", -1))
const _hoisted_52 = { key: 12 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Please let us know if you agree to us verifying your identity", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Do we have your permission to verify your identity with Equifax?", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "This will require us to share some of your information with them.", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Verifying your identity may allow us to speed up your applications for ID and benefits.")
], -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "However, you may opt-out if you'd prefer.", -1))
const _hoisted_60 = { key: 13 }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, "Sign here, and we can finish creating your account!", -1))
const _hoisted_62 = { key: 14 }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", {
  class: "pageHeading",
  style: {"text-align":"center"}
}, "Ok! We're ready to complete your registration", -1))
const _hoisted_64 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_65 = { key: 15 }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "You MUST click the button below to apply for ID and benefits", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pageHeading" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Click button below to apply for ID / benefits"),
  /*#__PURE__*/_createTextVNode(", and to access other resources.")
], -1))
const _hoisted_68 = { class: "is-flex is-flex-direction-column is-align-items-center" }
const _hoisted_69 = {
  key: 16,
  class: "notification bulmaNotification is-danger mt-4"
}
const _hoisted_70 = {
  key: 17,
  class: "is-flex is-flex-direction-row mt-6"
}
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))

import { 
    moduleState, initNewApplication, submitModule,
    sections, type Page,
    EquifaxConsentOptions,
    PryorStreetYesNo,
    HousingReadinessLocations,
    HousingReadinessType
} from './module';

import { validateCitizenInviteToken, isUsernameAvailable } from './api';
import { CitizenInvite, InformationCard, validateAndFlattenHmisClassifiers } from './model';

import { Core, Feature, ProfileTypes } from '@minicity/core';
import { isModuleEnabled, sessionState, endSession, tryToResumeSession } from '@/core/session';
import { uploadFile } from '@/core/api';

import LoadingSpinner from '@/components/LoadingSpinner.vue';
import LoadingPage from '@/components/LoadingPage.vue';
  
import { useForm, Form, PageSpecs } from '@/composables/useForm';
import { Validations } from '@/composables/useValidation';
import { useAsync } from '@/composables/useAsync';

import { computed, onMounted, ref, watch } from 'vue';
import { formatAge, mapHttpError } from '@/core/utils';
import { notifyNetworkError } from '@/core/utils';

import InformationCardField from './components/InformationCardField.vue';
import SignaturePadField from "@/components/SignaturePadField.vue";
import CategorySelector from './components/CategorySelector.vue';
import ClassifierQuestionField from './components/ClassifierQuestionField.vue';
import HmisClassifierQuestions from './components/HmisClassifierQuestions.vue';
import ValidationIndicator from "@/components/ValidationIndicator.vue";
import { InteractionType, logFeatureInteraction } from '@/features/analytics/api';

import MarkdownIt from "markdown-it";
import FormRadioGroupField from '@/components/FormRadioGroupField.vue';
import FormSelectField from '@/components/FormSelectField.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CitizenOnboardingForm',
  props: {
    inviteId: null
  },
  setup(__props: any) {

const props = __props as {
    inviteId: string
}



const invite = useAsync<CitizenInvite>();
const inviteErrorMessage = ref<string|null>(null);

/*
 * Define any special logic for each page
 */
const pages: PageSpecs<Page> = {
    "welcome": {
        nextPage: "termsAndWaivers",
    },
    "termsAndWaivers": {
        validate: ()=>{
            const state = moduleState.value!.miscState.termsAndWaivers;

            if (state.viewedTerms.length < invite.data!.terms.length) return ["Please read all of the terms and conditions"];
            if (!state.acceptedTerms)  return ["You need to accept the terms and conditions in order to continue"];

            moduleState.value!.application.agreedTermsVersion = invite.data!.termsVersion;
        },
        nextPage: "selectSiteAndCaseworker",
    },
    "selectSiteAndCaseworker": {
        validate: ()=>{
            const state = moduleState.value!.miscState.selectSiteAndCaseworker;

            if (!state.site) return ["Please select your location"];
            if (!state.caseworker) return ["Please select your caseworker"];

            if (invite.data!.partnerEnabledModules[Feature.Type.HOUSING_READINESS] == Feature.Status.ENABLED) {
                //if (state.housingReadinessLocation === null) return ["Please select your site / encampment"];
                if (state.housingReadinessLocation === null) return ["Please indicate if you are at Pryor Street"];
                moduleState.value!.application.housingReadinessLocation = state.housingReadinessLocation === "" ? undefined : state.housingReadinessLocation;

                console.log("ST", state);

                if (state.housingReadinessLocation === "") {
                    moduleState.value!.application.housingReadinessType = undefined;
                } else {
                    if (state.housingReadinessType === null) return ["Please indicate which housing type is most appropriate"];
                    moduleState.value!.application.housingReadinessType = state.housingReadinessType;
                }
            } else {
                moduleState.value!.application.housingReadinessLocation = undefined;
                moduleState.value!.application.housingReadinessType = undefined;
            }

            console.log("APPL", moduleState.value!.application);

            moduleState.value!.application.siteId = state.site.id;
            moduleState.value!.application.caseWorkerId = state.caseworker.id;
            moduleState.value!.application.assignedAmbassador = state.ambassador;
            moduleState.value!.application.hmisId = state.hmisId;
        },
        nextPage: "ambassadorSelfieCapture",
    },
    "ambassadorSelfieCapture": {
        enabled: ()=> moduleState.value!.application.assignedAmbassador != undefined,
        validate: ()=>{
            if (!moduleState.value?.application.verificationSelfie) return ["Please upload a selfie photo, to verify your identity"];
        },
        nextPage: "usernameAndPassword",
    },
    "usernameAndPassword": {},
    "basicCitizenInfo": {
        validate: ()=>{
            const profile = moduleState.value!.application.profile!;
            if (profile.firstName!.length == 0) return ["Please enter your first name"];
            if (profile.lastName!.length == 0) return ["Please enter your last name"];

            if (profile.socialSecurityNumber && profile.socialSecurityNumber.length != 0 && profile.socialSecurityNumber.length != 9)
                return ["Social Security Number should be in the form AAABBCCCC. Leave blank if not known"];

            if (!profile.dateOfBirth) return ["Please select your date of birth"];
            if (!profile.sex) return ["Please select your sex / gender"];
            if (!profile.race) return ["Please select your race / ethnicity"];
        },
        nextPage: "contactInfo",
    },
    "contactInfo": {
        validate: ()=>{
            const profile = moduleState.value!.application.profile!;
            
            if (profile.email) {
                if (profile.email.length == 0) {
                    profile.email = undefined;
                } else if (!Validations.email(profile.email)) {
                    return ["Please enter a valid email address, or leave blank"];
                }
            }

            if (profile.phoneNumber) {
                if (profile.phoneNumber.length == 0) {
                    profile.phoneNumber = undefined;
                } else if (!Validations.phone_US(profile.phoneNumber)) {
                    return ["Please enter a valid US phone number, or leave blank"];
                }
            }
        },
        nextPage: "demographicCategories",
    },
    "demographicCategories": {
        validate: ()=>{
            return [];
        },
        nextPage: "needsCategories",
    },
    "needsCategories": {
        validate: ()=>{
            return [];
        },
        nextPage: "classifierQuestions",
    },
    "classifierQuestions": {
        enabled: ()=> invite.data!.partnerEnabledModules[Feature.Type.LIFT_2_0] != Feature.Status.ENABLED,
        validate: ()=>{
            const answers = moduleState.value!.application.classifierQuestionAnswers!;
            
            for (let question of invite.data!.classifierQuestions) {
                if (answers[question.id].length > 0) {
                    if (answers[question.id].includes("Other:")) {
                        // "Other" selected, but no text provided
                        return [`Please write in your answer for the question: "${question.prompt}"`];    
                    }
                } else {
                    // No answer provided - auto-fill "prefer not to say" if that's an available option
                    if (question.answers.find(a => a.id == 'PREFER_NOT_TO_SAY')) {
                        answers[question.id] = ['PREFER_NOT_TO_SAY'];
                    } else {
                        return [`Please answer the question: "${question.prompt}"`];
                    }
                }
            }
        },
        nextPage: "hmisClassifierQuestions",
    },
    "hmisClassifierQuestions": {
        enabled: ()=> invite.data!.partnerEnabledModules[Feature.Type.LIFT_2_0] == Feature.Status.ENABLED,
        validate: ()=>{
            try {
                moduleState.value!.application.classifierQuestionAnswers = validateAndFlattenHmisClassifiers(moduleState.value!.miscState.hmisClassifierQuestions);
            } catch (ex) {
                return [`${ex}`];
            }
        },
        nextPage: "equifaxConsent",
    },
    "equifaxConsent": {
        enabled: ()=>isModuleEnabled(Feature.Type.EQUIFAX_CHECKS),
        onLoad: () => {
            const appl = moduleState.value!.application!;
            if (moduleState.value!.miscState.equifaxConsent.consent == null) {
                if (appl.equifaxConsent === true) {
                moduleState.value!.miscState.equifaxConsent.consent = EquifaxConsentOptions['Yes, my data can be shared'];
                } else if (appl.equifaxConsent === false) {
                    moduleState.value!.miscState.equifaxConsent.consent = EquifaxConsentOptions['No, do not share my data'];
                }
            }
        },
        validate: ()=>{
            const appl = moduleState.value!.application!;
            if (moduleState.value!.miscState.equifaxConsent.consent == null) return ["Please indicate whether you agree to us verifying your identity"];

            appl.equifaxConsent = moduleState.value!.miscState.equifaxConsent.consent == EquifaxConsentOptions['Yes, my data can be shared'];
        },
        nextPage: "signature"
    },
    "signature": {
        validate: ()=>{
            if ((signaturePad.value as any).isSignatureEmpty()) return ["Please provide your signature"];

            moduleState.value!.application.signature = (signaturePad.value as any).getSignatureData();
        },
        nextPage: "preSubmit"
    },
    "preSubmit": {},
    "completed": {disallowBack: true},
};


/*
 * Initialize
 */
onMounted(() => {
    if (sessionState.session || Boolean(localStorage["session"])) {
        // If we're logged-in, or there is a saved session tokem, force a logout
        endSession();
    }
    
    invite.fetch(validateCitizenInviteToken(props.inviteId))
    .then(invite => {
        startNewApplication();
    })
    .catch(err => {
        console.log(err.response)
        if (err.response.status == 401) {
            inviteErrorMessage.value = err.response.data;
        }
    });
});

const startNewApplication = () => {
    console.log("Starting new application");

    moduleState.value = initNewApplication({
        // Initial misc state
        termsAndWaivers: {
            viewedTerms: []
        },
        selectSiteAndCaseworker: {
            site: null,
            caseworker: null,
            ambassador: null,
            hmisId: null,
            housingReadinessLocation: null,
            housingReadinessEligibility: null,
        },
        equifaxConsent: {
            consent: null,
        },
        usernameAndPassword: {
            repeatPassword: ""
        },
        hmisClassifierQuestions: {}
    }, invite.data!);

    form.value = useForm(pages, sections, moduleState.value!.formNavState, onFormChanged);

    // Generate analytics event
    logFeatureInteraction("citizenOnboarding", "ONBOARDING", InteractionType.CLICK, JSON.stringify({'inviteId': props.inviteId}));
}


/*
 * Form state
 */
const form = ref<Form<Page>|null>(null);

const currentSection = computed(() => {
    if (!moduleState.value) return null;
    return form.value!.determineCurrentSection();
});

const onTermViewed = (term: InformationCard) => {
  if (moduleState.value!.miscState.termsAndWaivers.viewedTerms.includes(term.url)) return;
  moduleState.value!.miscState.termsAndWaivers.viewedTerms.push(term.url);
}

const signaturePad = ref(null);

const availableSites = computed(() => {
    if (!invite.data) return [];

    const sites:any = {};
    for (let s of invite.data.sites) {
        if (s.caseworkers.length > 0) {
            sites[s.name] = s;
        }
    }
    return sites;
});

const availableCaseworkers = computed(() => {
    if (!moduleState.value!.miscState.selectSiteAndCaseworker.site) return [];

    const caseworkers:any = {};
    for (let cw of moduleState.value!.miscState.selectSiteAndCaseworker.site.caseworkers) {
        caseworkers[cw.name] = cw;
    }
    return caseworkers;
});

const availableAmbassadors = computed(() => {
    if (!moduleState.value!.miscState.selectSiteAndCaseworker.caseworker) return [];

    const ambassadors:any = {};
    if (moduleState.value!.miscState.selectSiteAndCaseworker.caseworker.ambassadors) {
        for (let a of moduleState.value!.miscState.selectSiteAndCaseworker.caseworker.ambassadors) {
            ambassadors[a] = a;
        }
    }
    return ambassadors;
});

watch(() => moduleState.value?.miscState.selectSiteAndCaseworker.site, () => {
    const state = moduleState.value?.miscState.selectSiteAndCaseworker;
    if (!state) return;
    state.caseworker = state.site?.caseworkers.length == 1 ? state.site.caseworkers[0] : undefined;
    state.ambassador = undefined;
});

watch(() => moduleState.value?.miscState.selectSiteAndCaseworker.caseworker, () => {
    const state = moduleState.value?.miscState.selectSiteAndCaseworker;
    if (!state) return;
    state.ambassador = undefined;
});

const passwordValidationError = computed(() => {
    const minPasswordLength = 8;
    if (moduleState.value!.application.password!.length < minPasswordLength)
        return `Your password needs to be at least ${minPasswordLength} characters`;

    return null;
});

const repeatPasswordValidationError = computed(() => {
    if (moduleState.value!.application.password != moduleState.value!.miscState.usernameAndPassword.repeatPassword)
        return `Passwords do not match`;

    return null;
});

/*
 * Document uploads
 */
const deleteVerificationSelfie = (doc: Core.Document) => {
    moduleState.value!.application.verificationSelfie = undefined;
};
  
const uploadVerificationSelfie = (uploadInfo: {file: File, onDone: ()=>any}) => {
    uploadFile(uploadInfo.file, ['IMAGE'])
    .then(doc => {
        moduleState.value!.application.verificationSelfie = doc;
        moduleState.value!.formNavState.errors = [];
    })
    .catch(err => notifyNetworkError("Failed to upload selfie", err))
    .finally(() => uploadInfo.onDone());
}


/*
 * Form submission
 */
const onFormChanged = () => {
    // We could persist form state to localStorage here, to allow resuming onboarding later...
    // But that might be risky, as citizens could be using a shared device.
    // We don't want to accidently expose old incomplete form data to someone else using the device!
    // So, we'll err on the side of caution, and not support any save / resume functionality for onboarding.

    // Log analytics event
    logFeatureInteraction("citizenOnboarding", "ONBOARDING", InteractionType.PROGRESS, JSON.stringify({'inviteId': props.inviteId, 'page': form.value!.state.activePage, 'errors': form.value!.state.errors}));
};


const usernameCheckInProgress = ref<boolean>(false);

const checkUsername = async () => {
    if (moduleState.value!.application.username!.length == 0) {
        form.value!.state.errors = ["Please enter a username"];
        return;
    }
    
    if (passwordValidationError.value) {
        form.value!.state.errors = ["Please enter a valid password"];
        return;
    }

    if (repeatPasswordValidationError.value) {
        form.value!.state.errors = ["Please make sure your passwords match"];
        return;
    }

    form.value!.state.errors = [];
    console.log("Checking username", moduleState.value!.application.username);

    usernameCheckInProgress.value = true;
    try {
        const available = await isUsernameAvailable(invite.data!.id, moduleState.value!.application.username!);
        if (available) {
            form.value!.displayPage("basicCitizenInfo");
        } else {
            form.value!.state.errors = ["This username is already taken - please try another"];
        }
    } catch (ex) {
        form.value!.state.errors = [`${ex}`];
    } finally {
        usernameCheckInProgress.value = false;
    }
};


const submissionInProgress = ref<boolean>(false);

const submitApplication = async () => {
    form.value!.state.errors = [];
    console.log("Submitting", moduleState.value!.application);

    submissionInProgress.value = true;
    try {
        const response = await submitModule();
        tryToResumeSession(response.sessionId);

        form.value!.displayPage("completed");

        // Log analytics event
        logFeatureInteraction("citizenOnboarding/submit", "ONBOARDING", InteractionType.COMPLETION, JSON.stringify({'inviteId': props.inviteId}));
    } catch (ex) {
        form.value!.state.errors = [`Failed to submit - ${mapHttpError(ex)}`];

        // Log analytics event
        logFeatureInteraction("citizenOnboarding/submit", "ONBOARDING", InteractionType.ERROR, JSON.stringify({'inviteId': props.inviteId, 'errors': form.value!.state.errors}));
    } finally {
        submissionInProgress.value = false;
    }
};


return (_ctx: any,_cache: any) => {
  const _component_SaveButton = _resolveComponent("SaveButton")!
  const _component_Columns = _resolveComponent("Columns")!
  const _component_FormCheckboxField = _resolveComponent("FormCheckboxField")!
  const _component_HalfColumn = _resolveComponent("HalfColumn")!
  const _component_Column = _resolveComponent("Column")!
  const _component_FormTextField = _resolveComponent("FormTextField")!
  const _component_DocumentUploadWidget = _resolveComponent("DocumentUploadWidget")!
  const _component_FormDateField = _resolveComponent("FormDateField")!
  const _component_AppPageFrame = _resolveComponent("AppPageFrame")!

  return (_openBlock(), _createBlock(_component_AppPageFrame, {
    showHeader: "",
    login: "disallow"
  }, {
    default: _withCtx(() => [
      (_unref(invite).status == 'loading')
        ? (_openBlock(), _createBlock(LoadingPage, { key: 0 }))
        : (_unref(invite).status == 'error')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                (inviteErrorMessage.value)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      style: {"white-space":"pre-wrap"},
                      innerHTML: new _unref(MarkdownIt)().render(inviteErrorMessage.value)
                    }, null, 8, _hoisted_3))
                  : (_openBlock(), _createElementBlock("p", _hoisted_4, "The link you followed is invalid. Please check with your caseworker."))
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_SaveButton, {
                  large: "",
                  label: "Return To Home Page",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/')))
                })
              ])
            ]))
          : (_unref(invite).status == 'ready' && form.value && _unref(moduleState))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_unref(currentSection))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("h1", null, _toDisplayString(_unref(currentSection)?.name), 1),
                      (_unref(currentSection) != null)
                        ? (_openBlock(), _createElementBlock("progress", {
                            key: 0,
                            class: "progress is-primary mt-5",
                            value: 5 + _unref(currentSection).progress * 90,
                            max: "100"
                          }, null, 8, _hoisted_8))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'welcome')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _hoisted_10,
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("p", null, [
                          _hoisted_12,
                          _createElementVNode("strong", null, [
                            _hoisted_13,
                            _createElementVNode("em", null, _toDisplayString(_unref(invite).data.partnerName), 1),
                            _hoisted_14
                          ])
                        ]),
                        _createElementVNode("p", _hoisted_15, "If you are not a citizen at " + _toDisplayString(_unref(invite).data.partnerName) + ", please ask your caseworker for the correct link.", 1)
                      ]),
                      _hoisted_16
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'termsAndWaivers')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createVNode(_component_Columns, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invite).data.terms, (term) => {
                              return (_openBlock(), _createBlock(InformationCardField, {
                                key: term.url,
                                card: term,
                                size: "large",
                                viewed: _unref(moduleState).miscState.termsAndWaivers.viewedTerms.includes(term.url),
                                onViewed: ($event: any) => (onTermViewed(term))
                              }, null, 8, ["card", "viewed", "onViewed"]))
                            }), 128))
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_FormCheckboxField, {
                        class: "mt-4",
                        boxLabel: "Check here if you agree to these terms",
                        modelValue: _unref(moduleState).miscState.termsAndWaivers.acceptedTerms,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(moduleState).miscState.termsAndWaivers.acceptedTerms) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'selectSiteAndCaseworker')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _hoisted_21,
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(FormSelectField, {
                            label: "Your Location *",
                            options: _unref(availableSites),
                            allowNullSelection: Object.keys(_unref(availableSites)).length > 1,
                            modelValue: _unref(moduleState).miscState.selectSiteAndCaseworker.site,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(moduleState).miscState.selectSiteAndCaseworker.site) = $event))
                          }, null, 8, ["options", "allowNullSelection", "modelValue"])
                        ]),
                        _: 1
                      }),
                      (_unref(invite).data.partnerEnabledModules[_unref(Feature).Type.HOUSING_READINESS] == _unref(Feature).Status.ENABLED)
                        ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(FormRadioGroupField, {
                                label: "Are you at Pryor Street? *",
                                options: {'Yes': _unref(HousingReadinessLocations)['Pryor Street'], 'No': ''},
                                modelValue: _unref(moduleState).miscState.selectSiteAndCaseworker.housingReadinessLocation,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(moduleState).miscState.selectSiteAndCaseworker.housingReadinessLocation) = $event))
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(moduleState).miscState.selectSiteAndCaseworker.housingReadinessLocation)
                        ? (_openBlock(), _createBlock(_component_Column, { key: 1 }, {
                            default: _withCtx(() => [
                              _createVNode(FormRadioGroupField, {
                                label: "Which kind of housing is most appropriate for you? *",
                                options: _unref(HousingReadinessType),
                                modelValue: _unref(moduleState).miscState.selectSiteAndCaseworker.housingReadinessType,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(moduleState).miscState.selectSiteAndCaseworker.housingReadinessType) = $event))
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_unref(moduleState).miscState.selectSiteAndCaseworker.housingReadinessLocation)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_26))
                        : _createCommentVNode("", true),
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(FormSelectField, {
                            label: "Your Caseworker *",
                            options: _unref(availableCaseworkers),
                            allowNullSelection: Object.keys(_unref(availableCaseworkers)).length > 1,
                            isDisabled: Object.keys(_unref(availableCaseworkers)).length < 1,
                            modelValue: _unref(moduleState).miscState.selectSiteAndCaseworker.caseworker,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(moduleState).miscState.selectSiteAndCaseworker.caseworker) = $event))
                          }, null, 8, ["options", "allowNullSelection", "isDisabled", "modelValue"])
                        ]),
                        _: 1
                      }),
                      (Object.keys(_unref(availableAmbassadors)).length > 0)
                        ? (_openBlock(), _createBlock(_component_HalfColumn, { key: 3 }, {
                            default: _withCtx(() => [
                              _createVNode(FormSelectField, {
                                label: "Your Ambassador *",
                                options: _unref(availableAmbassadors),
                                allowNullSelection: "",
                                nullSelectionLabel: "-- I'm signing up without an ambassador --",
                                modelValue: _unref(moduleState).miscState.selectSiteAndCaseworker.ambassador,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(moduleState).miscState.selectSiteAndCaseworker.ambassador) = $event))
                              }, null, 8, ["options", "modelValue"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FormTextField, {
                            label: "HMIS ID (if known)",
                            modelValue: _unref(moduleState).miscState.selectSiteAndCaseworker.hmisId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(moduleState).miscState.selectSiteAndCaseworker.hmisId) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'ambassadorSelfieCapture')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _hoisted_28,
                      _createVNode(_component_DocumentUploadWidget, {
                        singleDocument: _unref(moduleState).application.verificationSelfie,
                        onUpload: _cache[8] || (_cache[8] = ($event: any) => (uploadVerificationSelfie($event))),
                        onDelete: _cache[9] || (_cache[9] = ($event: any) => (deleteVerificationSelfie($event)))
                      }, null, 8, ["singleDocument"]),
                      _hoisted_29
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'usernameAndPassword')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _hoisted_31,
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_FormTextField, {
                          label: "Username *",
                          modelValue: _unref(moduleState).application.username,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(moduleState).application.username) = $event)),
                          trimmed: "",
                          autoFocus: ""
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Password *",
                          isPassword: "",
                          modelValue: _unref(moduleState).application.password,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(moduleState).application.password) = $event))
                        }, {
                          top: _withCtx(() => [
                            (_unref(passwordValidationError))
                              ? (_openBlock(), _createBlock(ValidationIndicator, {
                                  key: 0,
                                  type: "error",
                                  tooltip: _unref(passwordValidationError)
                                }, null, 8, ["tooltip"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createVNode(_component_FormTextField, {
                          label: "Repeat Password *",
                          isPassword: "",
                          modelValue: _unref(moduleState).miscState.usernameAndPassword.repeatPassword,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(moduleState).miscState.usernameAndPassword.repeatPassword) = $event))
                        }, {
                          top: _withCtx(() => [
                            (_unref(repeatPasswordValidationError))
                              ? (_openBlock(), _createBlock(ValidationIndicator, {
                                  key: 0,
                                  type: "error",
                                  tooltip: _unref(repeatPasswordValidationError)
                                }, null, 8, ["tooltip"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        (usernameCheckInProgress.value)
                          ? (_openBlock(), _createBlock(LoadingSpinner, {
                              key: 0,
                              class: "mt-4"
                            }))
                          : (_openBlock(), _createBlock(_component_SaveButton, {
                              key: 1,
                              large: "",
                              label: "Proceed",
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (checkUsername()))
                            }))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'basicCitizenInfo' && _unref(moduleState).application.profile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _hoisted_34,
                      _createVNode(_component_Columns, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FormTextField, {
                            label: "First Name *",
                            modelValue: _unref(moduleState).application.profile.firstName,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(moduleState).application.profile.firstName) = $event)),
                            trimmed: "",
                            autoFocus: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormTextField, {
                            label: "Middle Name",
                            modelValue: _unref(moduleState).application.profile.middleName,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(moduleState).application.profile.middleName) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_FormTextField, {
                            label: "Last Name *",
                            modelValue: _unref(moduleState).application.profile.lastName,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(moduleState).application.profile.lastName) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FormTextField, {
                            label: "Your Social Security Number (if known)",
                            modelValue: _unref(moduleState).application.profile.socialSecurityNumber,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(moduleState).application.profile.socialSecurityNumber) = $event)),
                            trimmed: "",
                            length: 9,
                            isPassword: "",
                            noAutoFill: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(FormSelectField, {
                            label: "Your Sex / Gender *",
                            options: _unref(ProfileTypes).Sex,
                            allowNullSelection: "",
                            modelValue: _unref(moduleState).application.profile.sex,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(moduleState).application.profile.sex) = $event))
                          }, null, 8, ["options", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(FormSelectField, {
                            label: "Your Race / Ethnicity *",
                            options: _unref(ProfileTypes).Race,
                            allowNullSelection: "",
                            modelValue: _unref(moduleState).application.profile.race,
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(moduleState).application.profile.race) = $event))
                          }, null, 8, ["options", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_Columns, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FormDateField, {
                            label: "Date Of Birth *",
                            modelValue: _unref(moduleState).application.profile.dateOfBirth,
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(moduleState).application.profile.dateOfBirth) = $event)),
                            past: ""
                          }, null, 8, ["modelValue"]),
                          _createElementVNode("div", _hoisted_35, [
                            (_unref(moduleState).application.profile.dateOfBirth)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                                  _hoisted_37,
                                  _createElementVNode("strong", null, _toDisplayString(_unref(formatAge)(_unref(moduleState).application.profile.dateOfBirth)), 1),
                                  _hoisted_38
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'contactInfo' && _unref(moduleState).application.profile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _hoisted_40,
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FormTextField, {
                            label: "Email Address",
                            modelValue: _unref(moduleState).application.profile.email,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(moduleState).application.profile.email) = $event)),
                            trimmed: "",
                            autoFocus: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_HalfColumn, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_FormTextField, {
                            label: "Phone Number",
                            modelValue: _unref(moduleState).application.profile.phoneNumber,
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(moduleState).application.profile.phoneNumber) = $event)),
                            trimmed: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      (!_unref(moduleState).application.profile.email || _unref(moduleState).application.profile.email.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_43))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'demographicCategories')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                      _hoisted_45,
                      _createVNode(CategorySelector, {
                        modelValue: _unref(moduleState).application.demographics,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(moduleState).application.demographics) = $event)),
                        categories: [
                    {id: 'veteran', label: 'Veteran / Active Military'},
                    {id: 'disability', label: 'Disability'},
                    {id: 'fosterChild', label: 'Foster Child'},
                    {id: 'wardOfCourt', label: 'Ward of the Court'},
                    {id: 'parent', label: 'Parent'},
                    {id: 'singleParent', label: 'Single Parent'},
                ]
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'needsCategories')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                      _hoisted_47,
                      _createVNode(CategorySelector, {
                        modelValue: _unref(moduleState).application.needs,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(moduleState).application.needs) = $event)),
                        categories: [
                    {id: 'education', label: 'Educational Resources'},
                    {id: 'employment', label: 'Employment Resources'},
                    {id: 'medical', label: 'Medical Resources'},
                    {id: 'mentalHealth', label: 'Mental Health Resources'},
                    {id: 'childcare', label: 'Childcare'},
                    {id: 'financialAid', label: 'Financial Support'},
                    {id: 'transport', label: 'Transportation Help'},
                    {id: 'internetAccess', label: 'Internet Connectivity'},
                    {id: 'banking', label: 'Banking'},
                ]
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'classifierQuestions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                      _hoisted_49,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(invite).data.classifierQuestions, (question) => {
                        return (_openBlock(), _createBlock(ClassifierQuestionField, {
                          key: question.id,
                          question: question,
                          modelValue: _unref(moduleState).application.classifierQuestionAnswers[question.id],
                          "onUpdate:modelValue": ($event: any) => ((_unref(moduleState).application.classifierQuestionAnswers[question.id]) = $event),
                          class: "pt-3"
                        }, null, 8, ["question", "modelValue", "onUpdate:modelValue"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'hmisClassifierQuestions')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _hoisted_51,
                      _createVNode(HmisClassifierQuestions, {
                        modelValue: _unref(moduleState).miscState.hmisClassifierQuestions,
                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(moduleState).miscState.hmisClassifierQuestions) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (form.value.state.activePage == 'equifaxConsent')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _hoisted_53,
                      _hoisted_54,
                      _hoisted_55,
                      _hoisted_56,
                      _hoisted_57,
                      _hoisted_58,
                      _hoisted_59,
                      _createVNode(FormRadioGroupField, {
                        class: "mt-3",
                        label: "Do you agree to us verifying your identity? *",
                        options: _unref(EquifaxConsentOptions),
                        modelValue: _unref(moduleState).miscState.equifaxConsent.consent,
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(moduleState).miscState.equifaxConsent.consent) = $event))
                      }, null, 8, ["options", "modelValue"])
                    ]))
                  : (form.value.state.activePage == 'signature')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _hoisted_61,
                        _createVNode(_component_HalfColumn, { class: "mt-3" }, {
                          default: _withCtx(() => [
                            _createVNode(SignaturePadField, {
                              class: "column",
                              style: {"flex-grow":"1.8"},
                              ref_key: "signaturePad",
                              ref: signaturePad
                            }, null, 512)
                          ]),
                          _: 1
                        })
                      ]))
                    : (form.value.state.activePage == 'preSubmit')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                          _hoisted_63,
                          _createElementVNode("div", _hoisted_64, [
                            (submissionInProgress.value)
                              ? (_openBlock(), _createBlock(LoadingSpinner, {
                                  key: 0,
                                  class: "mt-4"
                                }))
                              : (_openBlock(), _createBlock(_component_SaveButton, {
                                  key: 1,
                                  large: "",
                                  label: "Submit!",
                                  icon: "fa-paper-plane",
                                  onClick: _cache[27] || (_cache[27] = ($event: any) => (submitApplication()))
                                }))
                          ])
                        ]))
                      : (form.value.state.activePage == 'completed')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                            _hoisted_66,
                            _hoisted_67,
                            _createElementVNode("div", _hoisted_68, [
                              _createVNode(_component_SaveButton, {
                                large: "",
                                label: "Apply For ID And Benefits",
                                onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.$router.push('/')))
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                (form.value!.state.errors.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(form.value.state.errors, (error) => {
                        return (_openBlock(), _createElementBlock("p", { key: error }, _toDisplayString(error), 1))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (!submissionInProgress.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                      (form.value.canNavigateBack())
                        ? (_openBlock(), _createBlock(_component_SaveButton, {
                            key: 0,
                            large: "",
                            label: "Back",
                            icon: "fa-chevron-left",
                            onClick: _cache[29] || (_cache[29] = ($event: any) => (form.value.navigateBack()))
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_71,
                      (form.value.canNavigateForward())
                        ? (_openBlock(), _createBlock(_component_SaveButton, {
                            key: 1,
                            large: "",
                            label: "Next",
                            icon: "fa-chevron-right",
                            iconRight: "",
                            onClick: _cache[30] || (_cache[30] = ($event: any) => (form.value.navigateForward()))
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})